import {
  FieldTypes,
  AIRTABLE,
  REST_API,
  DATABASE,
  EMAIL_TEMPLATE,
  SMS_TEMPLATE,
  FIREBASE_REALTIME_DATABASE,
  FIREBASE_CLOUD_FIRESTORE,
  FIREBASE_FUNCTION,
  INTEGROMAT,
  GOOGLE_SHEET,
  CHAT_GPT,
  TOOLTIP_TEMPLATE,
  TYPESENSE_SEARCH_TEMPLATE,
} from 'drapcode-constant';

export const drapcodeIcon = (type) => {
  switch (type) {
    case 'alarm':
      return 'webconnect-alarm';
    case 'description':
      return 'webconnect-info-circle';
    case 'warning':
      return 'webconnect-exclamation-triangle-fill';
    case 'collection':
    case 'dataSourceDatabase':
    case 'Data Sources':
    case DATABASE:
    case 'dbExport':
      return 'webconnect-database';
    case 'events':
    case 'indexing':
      return 'webconnect-diagram-3-fill';
    case 'conditions':
      return 'webconnect-signpost-2-fill';
    case 'data-source':
      return 'webconnect-hdd-stack-fill';
    case 'appSettings':
      return 'webconnect-home';
    case 'plugins':
      return 'webconnect-tools';
    case 'template':
    case 'PAGES':
    case 'pages':
    case 'js-update-page':
      return 'webconnect-file-alt';
    case SMS_TEMPLATE:
      return 'webconnect-chat-left-text';
    case TOOLTIP_TEMPLATE:
      return 'webconnect-info-circle-fill';
    case 'create':
    case 'add':
      return 'webconnect-plus';
    case 'update':
    case 'submit':
    case 'save':
      return 'webconnect-save-regular';
    case 'edit':
      return 'webconnect-pencil';
    case 'setup':
    case 'appConfig':
      return 'webconnect-cog';
    case 'configure':
    case 'advanced':
      return 'webconnect-cogs';
    case 'install':
      return 'webconnect-download';
    case 'info':
      return 'webconnect-info-circle-fill';
    case 'appConstant':
    case 'fields':
      return 'webconnect-form';
    case 'pageSettings':
    case 'pageSetting':
    case 'constructors':
      return 'webconnect-bricks';
    case 'pageSnapshots':
    case 'pageSnapshot':
    case 'derivedFields':
      return 'webconnect-box-arrow-in-right';
    case 'customCss':
    case 'customCSS':
      return 'webconnect-paint-brush';
    case 'constants':
      return 'webconnect-vector-pen';
    case 'snippetSnapshots':
    case 'snippetShapshot':
    case 'filters':
      return 'webconnect-funnel';
    case 'robotTxt':
    case 'robots':
    case 'constraints':
      return 'webconnect-gear';
    case 'list':
      return 'webconnect-card-list';
    case 'form':
      return 'webconnect-edit';
    case 'clear':
    case 'eraser':
    case 'reset':
    case 'clearBrowserSessionData':
      return 'webconnect-eraser';
    case 'delete':
      return 'webconnect-trash-solid';
    case 'validations':
      return 'webconnect-shield';
    case 'cancel':
      return 'webconnect-times';
    case 'next':
    case 'skip':
    case 'goto':
      return 'webconnect-skip-forward-fill';
    case 'dataSourceGoogleSheet':
    case GOOGLE_SHEET:
      return 'webconnect-file-spreadsheet';
    case 'dataSourceRestAPI':
    case REST_API:
    case 'ExternalAPIs':
    case 'External APIs':
      return 'webconnect-rocket';
    case 'devKey':
      return 'webconnect-key';
    case 'dataSourceAirtable':
    case AIRTABLE:
      return 'webconnect-table';
    case 'dataSourceFirebaseRealtimeDatabase':
    case FIREBASE_REALTIME_DATABASE:
      return 'webconnect-collection-fill';
    case 'dataSourceFirebaseFunction':
    case FIREBASE_FUNCTION:
      return 'webconnect-code-square';
    case 'dataSourceFirebaseCloudFirestore':
    case FIREBASE_CLOUD_FIRESTORE:
      return 'webconnect-cloudy-fill';
    case 'response':
    case 'terminal':
      return 'webconnect-terminal';
    case 'send':
    case 'send-request':
      return 'webconnect-cursor-fill';
    case 'back':
      return 'webconnect-chevron-double-left';
    case 'externalapi':
    case 'webhook':
      return 'webconnect-plug-fill';
    case 'integromat':
    case INTEGROMAT:
      return 'webconnect-power';
    case 'zapier':
    case 'ZAPIER':
      return 'webconnect-asterisk';
    case 'signUpUser':
    case 'signupAndLoginUser':
    case 'addNewUserToTenant':
    case 'createAndAddNewUserToTenant':
    case 'saveUserWithCollectionReference':
    case 'updateCurrentTenantData':
      return 'webconnect-person-plus-fill';
    case 'signupAndLoginAnonymousUser':
      return 'webconnect-person-lines-fill';
    case 'loginUser':
    case 'Login / Signup':
    case 'loginUserWithToken':
      return 'webconnect-login';
    case 'socialLoginSignup':
      return 'webconnect-person-circle';
    case 'logoutUser':
      return 'webconnect-logout';
    case 'system_show_component':
    case 'showModal':
    case 'showBulkUpdateModal':
    case 'Show / Hide Sections':
    case 'conditionalOpenModal':
      return 'webconnect-eye-fill';
    case 'displaySubPage':
      return 'webconnect-file-earmark-richtext';
    case 'goToPage':
    case 'Navigation':
    case 'navigation':
    case 'dynamicPageRedirect':
    case 'customPageRedirect':
      return 'webconnect-box-arrow-up-right';
    case 'sendEmail':
    case 'sendDynamicEmail':
    case 'sendResetPasswordEmail':
    case EMAIL_TEMPLATE:
      return 'webconnect-envelope-fill';
    case 'resetNewPassword':
      return 'webconnect-wrench';
    case 'chnageOldPassword':
      return 'webconnect-front';
    case 'showAlertMessage':
    case 'Notification':
      return 'webconnect-megaphone-fill';
    case 'saveUserWithCollectionReference':
    case 'saveCollectionWithReferenceItems':
    case 'saveCollection':
      return 'webconnect-save-solid';
    case 'updateCollectionWithReferenceItems':
    case 'updateCollection':
    case 'bulkUpdateCollection':
      return 'webconnect-save-regular';
    case 'updateCollectionOnPageLoad':
    case 'updateCollectionFieldDerivedField':
    case 'updateCollectionFieldBrowserSession':
      return 'webconnect-save-fill';
    case 'addToCollectionItem':
      return 'webconnect-layers-fill';
    case 'removeFromCollectionItem':
      return 'webconnect-layers-half';
    case 'deleteCollectionItem':
    case 'removeCollectionFieldData':
      return 'webconnect-trash-solid';
    case 'sendDataToExternalApi':
      return 'webconnect-cloud-fog2-fill';
    case 'sendDataToExternalApiAndFileDownload':
      return 'webconnect-cloud-arrow-down';
    case 'fileUpload':
      return 'webconnect-upload';
    case 'system_hide_component':
      return 'webconnect-eye-slash-fill';
    case 'closeModal':
      return 'webconnect-x-circle';
    case 'reloadPage':
    case 'refreshCurrentLoggedInUser':
    case 'refreshCurrentTenant':
      return 'webconnect-refresh';
    case 'refreshSection':
    case 'loadingIcon':
      return 'webconnect-arrow-repeat';
    case 'Collection':
      return 'webconnect-stack';
    case 'Snippet / Modal Popup':
      return 'webconnect-clone';
    case 'ExternalApis':
    case 'localization':
    case 'switchLocalizationLang':
      return 'webconnect-globe';
    case 'customCSSClasses':
      return 'webconnect-palette';
    case 'workflow':
      return 'webconnect-bar-chart-steps';
    case 'team':
    case 'teamManagement':
    case 'updateCurrentLoggedInUserData':
    case 'Multi Tenant':
      return 'webconnect-people-fill';
    case 'important':
      return 'webconnect-pin-angle-fill';
    case 'environment':
      return 'webconnect-inboxes';
    case 'customCSSURL':
    case 'customCssUrl':
    case 'customJSCDN':
    case 'customJsCDN':
      return 'webconnect-link-45deg';
    case 'customCSSFileUpload':
    case 'customCssFileUpload':
      return 'webconnect-file-earmark-arrow-up';
    case 'customJS':
    case 'customJs':
      return 'webconnect-puzzle';
    case 'snapshot':
    case 'snapshots':
      return 'webconnect-camera-fill';
    case 'customCssJs':
      return 'webconnect-sliders';
    case 'pwa':
    case 'pwaConfig':
    case 'mobile':
    case 'phone':
      return 'webconnect-phone';
    case 'search':
    case TYPESENSE_SEARCH_TEMPLATE:
      return 'webconnect-search';
    case 'text':
      return 'webconnect-capital';
    case 'header':
      return 'webconnect-heading';
    case 'paragraph':
      return 'webconnect-paragraph';
    case 'bootstrap_button':
      return 'webconnect-bootstrap-fill';
    case 'link':
      return 'webconnect-link-45deg';
    case 'form':
    case 'collection-form':
    case 'login-form':
    case 'search-form':
      return 'webconnect-newspaper';
    case 'input':
      return 'webconnect-input';
    case 'select':
      return 'webconnect-menu-button-wide-fill';
    case 'data-table':
      return 'webconnect-table';
    case 'data-list':
      return 'webconnect-list-square-rounded-interface';
    case 'data-group':
      return 'webconnect-list-2';
    case 'browser-storage-setter':
      return 'webconnect-list-2';
    case 'Import/Export Collection Data':
      return 'webconnect-file-earmark-zip';
    case 'importCollectionItem':
      return 'webconnect-file-arrow-up';
    case 'exportCollectionItem':
      return 'webconnect-file-arrow-down';
    case 'codeExport':
      return 'webconnect-cloud-download';
    case 'navbar':
      return 'webconnect-menu-button-wide-fill';
    case 'drapcode-icons':
      return 'webconnect-star';
    case 'iframe':
      return 'webconnect-frame';
    case 'link-box':
      return 'webconnect-link';
    case 'box':
      return 'webconnect-square';
    case 'jumbotron':
      return 'webconnect-credit-card-2-front-fill';
    case 'stripe-connect-buy':
      return 'webconnect-cart-check';
    case 'timeout':
      return 'webconnect-hourglass-split';
    case 'error':
      return 'webconnect-x-circle';
    case 'logs':
      return 'webconnect-file-text';
    case 'resetFormFields':
      return 'webconnect-eraser-fill';
    case 'Form':
      return 'webconnect-file-earmark-text-fill';
    case 'submitSelectedForm':
      return 'webconnect-save2-fill';
    case 'showConfirmationMessage':
      return 'webconnect-shield-fill-exclamation';
    case 'customTheme':
      return 'webconnect-file-zip';
    case 'dependentDropDownPopulateOnChange':
      return 'webconnect-menu-button-wide-fill';
    case 'triggerZap':
      return 'webconnect-cloud-fog2';
    case 'encryption':
    case 'sendDataToExternalApiAndAuthorize':
    case 'Permission':
      return 'webconnect-shield-lock ';
    case 'decryption':
      return 'webconnect-shield-slash';
    case 'continue':
      return 'webconnect-arrow-right';
    case 'previous':
      return 'webconnect-arrow-left';
    case 'sync':
      return 'webconnect-arrow-left-right';
    case 'step-complete':
      return 'webconnect-check2-circle';
    case 'step-pending':
      return 'webconnect-plus-circle-dotted';
    case 'version':
      return 'webconnect-patch-plus';
    case 'toggle':
      return 'webconnect-toggles';
    case 'notification':
    case 'notificationSetting':
      return 'webconnect-bell';
    case 'meta-fields':
      return 'webconnect-receipt';
    case 'removeTenantFromMultipleRoles':
    case 'removeUserFromTenant':
      return 'webconnect-person-dash-fill';
    case 'addUserToTenant':
      return 'webconnect-person-check-fill';
    case 'switchUserTenant':
      return 'webconnect-address-book';
    case 'setBrowserSessionData':
      return 'webconnect-journal-plus';
    case 'dateFormat':
      return 'webconnect-calendar2-month';
    case 'customComponent':
    case 'displayCustomComponent':
      return 'webconnect-easel';
    case 'htmlContent':
      return 'webconnect-code-slash';
    case 'saveCollectionDraft':
      return 'webconnect-archive-fill';
    case 'updateCollectionDraft':
      return 'webconnect-archive';
    case 'switchEntity':
      return 'webconnect-box-seam';
    case 'customDataMapping':
      return 'webconnect-bezier2';
    case 'dashboard':
      return 'webconnect-x-diamond-fill';
    case 'PROFILER':
    case 'profiler':
      return 'webconnect-speedometer2';
    case 'system-activity':
      return 'webconnect-cpu';
    case 'publish-activity':
      return 'webconnect-paper-plane';
    case 'pause':
      return 'webconnect-pause';
    case 'resume':
      return 'webconnect-play';
    case 'on-boarding':
      return 'webconnect-house-door-fill';
    case 'AI/ChatGPT':
    case 'AI / ChatGPT':
      return 'webconnect-lightbulb-fill';
    case 'resources':
      return 'webconnect-cloud-arrow-up';
    case 'sendDynamicMessage':
      return 'webconnect-chat-left-text';
    case 'view':
      return 'webconnect-eye';
    case 'remove':
      return 'webconnect-trash-regular';
    case 'verifyTwoFactorAuthentication':
    case 'verificationprocess':
      return 'webconnect-shield-lock-fill';
    case 'pdfToText':
      return 'webconnect-file-text';
    default:
      return 'webconnect-edit';
  }
};

export const iconForField = (type) => {
  if ([FieldTypes.date.id, FieldTypes.unix_timestamp.id].includes(type))
    return 'webconnect-calendar2-month';
  if (type === FieldTypes.password.id) return 'webconnect-key';
  if (type === FieldTypes.color.id) return 'webconnect-palette';
  if (type === FieldTypes.file.id) return 'webconnect-paperclip';
  if (type === FieldTypes.belongsTo.id) return 'webconnect-share';
  if (type === FieldTypes.reference.id) return 'webconnect-inboxes';
  if (type === FieldTypes.image.id) return 'webconnect-image';
  if (type === FieldTypes.multi_image.id) return 'webconnect-images-regular';
  if (type === FieldTypes.video_link.id) return 'webconnect-camera-video';
  if (type === FieldTypes.url.id) return 'webconnect-link';
  if (type === FieldTypes.tel.id) return 'webconnect-telephone';
  if (type === FieldTypes.email.id) return 'webconnect-at';
  if (type === FieldTypes.dynamic_option.id) return 'webconnect-collection';
  if (type === FieldTypes.static_option.id) return 'webconnect-justify';
  if (type === FieldTypes.large_text.id) return 'webconnect-newspaper';
  if (type === FieldTypes.number.id) return 'webconnect-sort-numeric-up-alt';
  if (type === FieldTypes.boolean.id || type === 'checkbox') return 'webconnect-check-square';
  if (type === 'text') return 'webconnect-pencil';
  if (type === FieldTypes.boolean.id + '-toggle') return 'webconnect-toggles';
  if (type === 'select' || type === 'dropdown') return 'webconnect-menu-button-wide-fill';
  if (
    type === 'text-placeholder' ||
    type === FieldTypes.custom_uuid.id ||
    type === FieldTypes.json.id
  )
    return 'webconnect-braces';
  if (type === 'sidebar') return 'webconnect-layout-text-sidebar';
  if (type === 'reverse-sidebar') return 'webconnect-layout-text-sidebar-reverse';
  if (type === 'diagram-2') return 'webconnect-diagram-2';
  if (type === 'capslock') return 'webconnect-capslock';
  if (type === 'sort-up') return 'webconnect-sort-up';
  if (type === 'files') return 'webconnect-files';
  if (type === 'devKey') return 'webconnect-key';
  if (type === FieldTypes.time_slot.id) return 'webconnect-calendar2-plus';

  return 'webconnect-file-text';
};

export const drapcodeImgIcon = (name, type = 'dataSource', ext = 'png') => {
  let imgName = '';
  switch (name) {
    case 'supabase':
    case 'Supabase':
    case 'SUPABASE':
      imgName = 'supabase';
      break;
    case 'appwrite':
    case 'Appwrite':
    case 'APPWRITE':
      imgName = 'appwrite';
      break;
    case 'xano':
    case 'Xano':
    case 'XANO':
      imgName = 'xano';
      break;
    case 'xata':
    case 'Xata':
    case 'XATA':
      imgName = 'xata';
      break;
    case 'directus':
    case 'Directus':
    case 'DIRECTUS':
      imgName = 'directus';
      break;
    case 'airtable':
    case 'Airtable':
    case 'AIRTABLE':
      imgName = 'airtable';
      break;
    case 'salesforce':
    case 'Salesforce':
    case 'SALESFORCE':
      imgName = 'salesforce';
      break;
    case 'postgresql':
      imgName = 'postgresql';
      break;
    case 'mysql':
      imgName = 'mysql';
      break;
    case 'sqlite':
      imgName = 'sqlite';
      break;
    case 'ms-sql-server':
      imgName = 'ms-sql-server';
      break;
    case 'oracledb':
      imgName = 'oracledb';
      break;
    case 'mariadb':
      imgName = 'mariadb';
      break;
    case 'aurora':
      imgName = 'aurora';
      break;
    default:
      if (ext) {
        imgName = ext === 'svg' ? 'database' : 'drapcode';
      } else {
        imgName = 'drapcode';
      }
      break;
  }
  try {
    return require(`../${type || 'dataSource'}/img/${imgName}.${ext || 'png'}`);
  } catch (error) {
    //Fallback to drapcode image icon
    return require(`../dataSource/img/drapcode.png`);
  }
};
